import { ChangeDetectorRef, Component, OnInit } from '@angular/core'
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { CustomFormValidators } from '@spartacus/storefront'
import { ContactForm } from '../../models/contact.model'
import { BaseCountry } from '../../models/enum/country.enum'
import { AppConfigurationService } from '../../services/app-configuration.service'
import { ContactService } from '../../services/contact.service'
import { NotificationMessageService } from '../../services/notification-message.service'
import { SharedService } from '../../services/shared/shared.service'
import {
  ICustomSelectOptionContact,
  ICustomSelectOptionReason
} from '../shared/custom-components/custom-select/modals/interface/custom-select.interface'

@Component({
    selector: 'app-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.scss'],
    standalone: false
})
export class ContactUsComponent implements OnInit {
  constructor(
    private fb: FormBuilder,
    private contactService: ContactService,
    private notificationMessageService: NotificationMessageService,
    private appConfigurationService: AppConfigurationService,
    private changeDetectorRef: ChangeDetectorRef,
    private sharedService: SharedService
  ) {}

  public contactForm: FormGroup
  public siteKey = ''
  public formSubmitted: boolean = false
  public spinner: boolean = false
  public minPhoneNumberLength: number
  reasonOptions: any = []
  reasonOptionstest: any = []
  public hideData: boolean = false
  public dropDown: boolean = false
  public showloggedin: boolean = true
  public userNotes: boolean = false
  public hideReason: boolean = true
  public selectClaimcheckbox: boolean = false
  public loggedin = sessionStorage.getItem('userDetails')
  public userlog: any

  //select last row..
  public claimNo = false
  public agreement = false
  public folcredit = false
  public folOrder = false
  public Invoice = false
  public Order = false
  public poNumber = false

  public enquiryOptions: ICustomSelectOptionContact[] = [
    { id: 1, label: 'contactUs.accountAccess', value: 'Account Details' },
    { id: 2, label: 'contactUs.creditclaim', value: 'Claim' },
    { id: 3, label: 'contactUs.fol', value: 'Free On Loan' },
    { id: 4, label: 'contactUs.invoiceCopy', value: 'Invoice Copy' },
    { id: 5, label: 'contactUs.orderEnquiry', value: 'Order Enquiry' },
    { id: 6, label: 'contactUs.delivery', value: 'Proof of Delivery' },
    { id: 7, label: 'contactUs.priceRebate', value: 'Price Enquiry' },
    { id: 8, label: 'contactUs.productEnquiry', value: 'Product enquiry' },
    { id: 9, label: 'contactUs.other', value: 'Other' }
  ]

  public enquiryOptionsReasonUnregister: ICustomSelectOptionReason[] = [
    { id: 1, value: 'I am following up on my request to update my account details', newid: 1 },
    { id: 1, value: 'I tried to reset my password but something went wrong', newid: 2 },
    { id: 1, value: 'Other', newid: 3 },

    { id: 2, value: 'Following up on a Claim', newid: 1 },
    { id: 2, value: ' I want to submit a Credit Claim', newid: 2 },
    { id: 2, value: 'Other', newid: 3 },

    { id: 3, value: 'Following up on a FOL agreement', newid: 1 },
    { id: 3, value: 'Following up on a FOL credit', newid: 2 },
    { id: 3, value: 'Following up on a FOL order', newid: 3 },
    { id: 3, value: 'Other', newid: 4 },

    { id: 5, value: 'Following up on an Order', newid: 1 },
    { id: 5, value: 'I am unable to submit an Order', newid: 2 },
    { id: 5, value: 'Other', newid: 3 },

    { id: 7, value: 'Pricing Rebate ', newid: 1 },
    { id: 7, value: 'Pricing Discrepancy', newid: 2 },
    { id: 7, value: 'Other', newid: 3 },

    { id: 8, value: 'What would you recommend?', newid: 1 },
    { id: 8, value: 'I am looking for additional information', newid: 2 },
    { id: 8, value: 'Other', newid: 3 }
  ]

  filterChangeUnregister(event) {
    this.claimNo = false
    this.agreement = false
    this.folcredit = false
    this.folOrder = false
    this.Invoice = false
    this.Order = false
    this.poNumber = false

    this.reasonOptions = this.enquiryOptionsReasonUnregister.filter((i) => i.id == event.value.id)
    this.dropDown = true
    // if(event.value == 1 || event.value == 7 || event.value == 8 || event.value == 9 ){
    //   this.userNotes = false;

    // }

    if (event.value.id == 4 || event.value.id == 6) {
      this.Invoice = true
      this.hideReason = false
    } else if (event.value.id == 9) {
      this.hideReason = false
    } else {
      this.hideReason = true
      this.Invoice = false
    }
    if (event.value.id == 9) {
      this.hideReason = false
    }
  }

  // Register user
  public enquiryOptionsReasonregister: ICustomSelectOptionReason[] = [
    { id: 1, value: 'I am following up on my request to update my account details', newid: 1 },
    //{id:1, value: "I tried to reset my password but something went wrong" , newid:2 },
    { id: 1, value: 'Other', newid: 3 },

    { id: 2, value: 'Following up on a claim', newid: 1 },
    { id: 2, value: 'Other', newid: 2 },

    { id: 3, value: 'Following up on a FOL agreement', newid: 1 },
    { id: 3, value: 'Following up on a FOL credit', newid: 2 },
    { id: 3, value: 'Following up on a FOL order', newid: 3 },
    { id: 3, value: 'Other', newid: 4 },

    { id: 5, value: 'Following up on an Order', newid: 1 },
    { id: 5, value: 'I am unable to submit an Order', newid: 2 },
    { id: 5, value: 'Other', newid: 3 },

    { id: 7, value: 'Pricing Rebate', newid: 1 },
    { id: 7, value: 'Pricing Discrepancy', newid: 2 },
    { id: 7, value: 'Other', newid: 3 },

    { id: 8, value: 'What would you recommend?', newid: 1 },
    { id: 8, value: 'I am looking for additional information', newid: 2 },
    { id: 8, value: 'Other', newid: 3 }
  ]

  filterChangeRegister(event) {
    this.claimNo = false
    this.agreement = false
    this.folcredit = false
    this.folOrder = false
    this.Invoice = false
    this.Order = false
    this.poNumber = false
    this.reasonOptionstest = this.enquiryOptionsReasonregister.filter((i) => i.id == event.value.id)
    this.dropDown = true
    if (event.value.id == 4 || event.value.id == 6) {
      this.Invoice = true
      this.hideReason = false
      this.folOrder = false
      this.contactForm.addControl('reason', new FormControl(''))
    } else if (event.value.id == 9) {
      this.hideReason = false
    } else {
      this.hideReason = true
      this.Invoice = false
      this.contactForm.addControl('reason', new FormControl('', Validators.required))
    }
  }

  lastfilterChangeRegister(event) {
    this.selectClaimcheckbox = false
    this.claimNo = false
    this.agreement = false
    this.folcredit = false
    this.folOrder = false
    this.Invoice = false
    this.Order = false
    this.poNumber = false

    if (event.value.id == 9) {
      this.hideReason = false
    }

    if (event.value.id === 2 && event.value.newid === 1) {
      this.claimNo = true
    } else if (event.value.id === 2 && event.value.newid === 2) {
      this.selectClaimcheckbox = false
    } else if (event.value.id === 3 && event.value.newid === 1) {
      this.agreement = true
    } else if (event.value.id === 3 && event.value.newid === 2) {
      this.folcredit = true
      this.agreement = false
    } else if (event.value.id === 3 && event.value.newid === 3) {
      this.folOrder = true
      this.folcredit = false
    } else if (event.value.id === 5 && (event.value.newid === 1) == true) {
      this.poNumber = true
    } else if (event.value.id === 5 && (event.value.newid === 2 || event.value.newid === 3) == true) {
      this.poNumber = false
    } else {
      this.claimNo = false
      this.agreement = false
      this.folcredit = false
      this.folOrder = false
      this.Invoice = false
      this.Order = false
      this.poNumber = false
    }
  }

  lastdropUnRegister(event) {
    this.selectClaimcheckbox = false
    this.claimNo = false
    this.agreement = false
    this.folcredit = false
    this.folOrder = false
    this.Invoice = false
    this.Order = false
    this.poNumber = false

    if (event.value.id === 2 && event.value.newid === 1) {
      this.claimNo = true
    } else if (event.value.id === 2 && event.value.newid === 2) {
      this.selectClaimcheckbox = true
    } else if (event.value.id === 2 && event.value.newid === 3) {
      this.selectClaimcheckbox = false
    } else if (event.value.id === 3 && event.value.newid === 1) {
      this.agreement = true
    } else if (event.value.id === 3 && event.value.newid === 2) {
      this.folcredit = true
      this.agreement = false
    } else if (event.value.id === 3 && event.value.newid === 3) {
      this.folOrder = true
      this.folcredit = false
    } else if (event.value.id === 5 && (event.value.newid === 1) == true) {
      this.poNumber = true
    } else if (event.value.id === 5 && (event.value.newid === 2 || event.value.newid === 3) == true) {
      this.poNumber = false
    } else {
      this.claimNo = false
      this.agreement = false
      this.folcredit = false
      this.folOrder = false
      this.Invoice = false
      this.Order = false
      this.poNumber = false
    }
  }

  ngOnInit(): void {
    this.siteKey = this.appConfigurationService.getRecaptchaSitekey()
    this.contactForm = this.fb.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      email: ['', [Validators.required, CustomFormValidators.emailValidator]],
      phone: ['', [Validators.required, this.ValidatePhone]],

      company: ['', [Validators.required]],

      essityAccount: ['', [Validators.required]],
      enquiry: ['', [Validators.required]],
      reason: [''],
      // reason:['',[Validators.required]],

      claimNumber: [''],
      agreemntNumber: [''],
      folcredit: [''],
      folOrder: [''],
      invoiceNumber: [''],
      Order: [''],

      poNumber: [''],

      message: ['', [Validators.required]],
      terms: [false, [Validators.required]],
      recaptcha: ['', Validators.required]
    })

    if (this.sharedService.baseSiteId === BaseCountry.AU) {
      this.minPhoneNumberLength = 10
    } else {
      this.minPhoneNumberLength = 8
    }

    this.userlog = JSON.parse(this.loggedin)
    if (this.loggedin == null) {
      this.hideData = true
      this.showloggedin = false
    } else {
      this.contactForm = this.fb.group({
        firstName: [''],
        lastName: [''],
        email: [''],
        phone: ['', [Validators.required, this.ValidatePhone]],
        company: [''],
        essityAccount: [''],
        enquiry: ['', [Validators.required]],
        // reason:['',[Validators.required]],
        reason: [''],
        claimNumber: [''],
        agreemntNumber: [''],
        folcredit: [''],
        folOrder: [''],
        invoiceNumber: [''],
        Order: [''],

        poNumber: [''],

        message: ['', [Validators.required]],
        terms: [false, [Validators.required]],
        recaptcha: ['', Validators.required]
      })

      this.contactForm.get('firstName').setValue(this.userlog.firstName)
      this.contactForm.get('lastName').setValue(this.userlog.lastName)
      this.contactForm.get('email').setValue(this.userlog.uid)
      this.contactForm.get('phone').setValue(this.userlog.phoneNumber)
      this.contactForm.get('company').setValue(this.userlog.orgUnit.name)
      this.contactForm.get('essityAccount').setValue(this.userlog.orgUnit.uid)
    }
    sessionStorage.clear()
  }

  public ValidatePhone(control: AbstractControl): { [key: string]: any } | null {
    let value = control?.value
    const pattern = /^[+]?(\d+\s?)*\d+$/
    if (value) {
      value = value.replace(/ /g, '')
    }

    switch (true) {
      case !pattern.test(value):
        return { invalidPhoneNumber: true }

      case value.length > 12:
        return { maxPhoneNumber: true }

      default:
        return null
    }
  }

  public get disableForm(): boolean {
    if (!this.contactForm.valid) {
      return true
    } else {
      let value = this.contactForm?.get('phone')?.value
      value = value?.replace(/ /g, '')
      if (value?.length < this.minPhoneNumberLength) {
        return true
      }
    }
    return false
  }

  onSubmit(): void {
    this.spinner = true
    if (this.contactForm.valid) {
      this.contactService.submitContact(this.collectDataFromContactForm(this.contactForm.value)).subscribe(
        (data) => {
          this.formSubmitted = true
          this.spinner = false
          this.changeDetectorRef.detectChanges()
        },
        (error) => {
          this.notificationMessageService.openSnackBar(false, 'Failed to submit the contact form. please try again')
          this.spinner = false
          this.changeDetectorRef.detectChanges()
        }
      )
    } else {
      this.contactForm.markAllAsTouched()
    }
  }

  public collectDataFromContactForm(formData: any): ContactForm {
    const {
      firstName,
      lastName,
      email,
      company,
      phone,
      enquiry,
      reason,
      essityAccount,
      claimNumber,
      agreemntNumber,
      folcredit,
      folOrder,
      invoiceNumber,
      Order,
      poNumber,
      message,
      termsAndConditions = true
    } = formData
    return {
      firstName,
      lastName,
      email,
      company,
      phone,
      enquiry,
      reason,
      essityAccount,
      claimNumber,
      agreemntNumber,
      folcredit,
      folOrder,
      invoiceNumber,
      Order,
      poNumber,
      message,
      termsAndConditions
    }
  }

  onRecaptchaSuccess(): void {
    this.contactForm.markAllAsTouched()
  }

  public onCancel(): void {
    this.contactForm.reset()
  }

  public onFormRestartClicked(): void {
    this.formSubmitted = false
    this.contactForm.reset()
    this.ngOnInit()
    this.changeDetectorRef.detectChanges()
  }
}
